'use client';

import { createContext, useContext, useState, ReactNode } from 'react';

interface WaitlistContextType {
  isOpen: boolean;
  openWaitlist: (source?: string) => void;
  closeWaitlist: () => void;
  source: string;
}

const WaitlistContext = createContext<WaitlistContextType | undefined>(undefined);

export function WaitlistProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [source, setSource] = useState('');

  const openWaitlist = (src?: string) => {
    setSource(src || 'modal');
    setIsOpen(true);
  };

  const closeWaitlist = () => {
    setIsOpen(false);
  };

  return (
    <WaitlistContext.Provider value={{ isOpen, openWaitlist, closeWaitlist, source }}>
      {children}
    </WaitlistContext.Provider>
  );
}

export function useWaitlist() {
  const context = useContext(WaitlistContext);
  if (context === undefined) {
    throw new Error('useWaitlist must be used within a WaitlistProvider');
  }
  return context;
}
